<template>
  <v-form ref="mainForm" v-model="valid">
    <data-iterator
      :list="sasRecherches"
      add-new-text="Ajouter une recherche"
      :live="{ endpoint: 'sas-equivalence-recherche', sasId: sas.id }"
      optional
      card-width="900"
      :icon="$getIcon('recherche')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3>{{ item.titre }}</h3>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-text-field code="titre-recherche" v-model="item.titre" :live="liveSasRecherches(7402, item)"></opq-text-field>
        <opq-memo code="methodologie-recherche" v-model="item.methodologie" :live="liveSasRecherches(7403, item)"></opq-memo>
        <opq-memo code="precisions-recherche" v-model="item.precision" :live="liveSasRecherches(7404, item)"></opq-memo>
        <opq-memo code="resultats-recherche" v-model="item.resultats" :live="liveSasRecherches(7405, item)"></opq-memo>
        <opq-memo code="references-recherche" v-model="item.references" :live="liveSasRecherches(7406, item)"></opq-memo>
        <opq-memo code="credits-recherche" v-model="item.credits" :live="liveSasRecherches(7407, item)"></opq-memo>
        <opq-file-multiple code="fichier-recherche" :files="item.versionIntegraleRecherche" :live="liveSasRecherches(7408, item)"></opq-file-multiple>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
export default {
  mixins: [FormHybrid],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasRecherches(cle, item) {
      return { endpoint: "sas-equivalence-recherche", cle: cle, fileId: item.id }
    }
  },

  computed: {
    sasRecherches() {
      return this.sas.recherches
    }
  }
}
</script>

<style>
</style>